import { TokenData } from '../interfaces/Auth';

const tokenKey = 'nnet-auth-token';

export const getStoredToken = (): string | null =>
  localStorage.getItem(tokenKey);

export const storeToken = (token: string) =>
  localStorage.setItem(tokenKey, token);

export const removeToken = () => localStorage.removeItem(tokenKey);

const parseTokenData = (payload: string): TokenData | undefined => {
  let rawPayload;
  try {
    rawPayload = JSON.parse(payload);
  } catch {
    return undefined;
  }

  return {
    email: rawPayload.email,
    expiresAt: new Date((rawPayload.exp ?? 0) * 1000),
  };
};

export const getTokenData = (): TokenData | undefined => {
  const jwt = getStoredToken();
  if (!jwt) {
    return undefined;
  }

  const parts = jwt.split('.');
  if (parts.length < 2) {
    return undefined;
  }

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const payloadJson = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join(''),
  );

  return parseTokenData(payloadJson);
};

export const isTokenValid = (): boolean => {
  const tokenData = getTokenData();
  return tokenData
    ? tokenData.expiresAt.getTime() > new Date().getTime()
    : false;
};
